<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm05_con"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm06_pre#ch00_fm06_pre"><em>Preface</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm08_intro#ch00_fm08_intro">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">1 Under Suspicious Circumstances: The (Critical)<br/>Disappearance of Anna Seward</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 “Fancy’s Shrine”: Lady Miller’s Batheaston Poetical Assemblies</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 The Profession of Poetry</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 British Patriot</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Wartime Correspondent: The French Wars<br/>and Late-Century Patriotism</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Seward and Sensibility: <em>Louisa, a Poetical Novel, in Four Epistles</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 <em>Louisa</em> and the Late Eighteenth-Century Family Romance</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 Milton’s Champion</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 Corresponding Poems</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 The “Lost” Honora</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 <em>Memoirs of the Life of Dr. Darwin</em>: Digging in <em>The Botanical Garden</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 Anna Seward, Samuel Johnson, and the End<br/>of the Eighteenth Century</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13_notes#ch13_notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch14_biblio#ch14_biblio" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch15_index#ch15_index" title="Link target outside of Sample"><em>Index</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_con.vue?2aec912f